import { multicallAddresses } from '@pancakeswap/multicall'

export default {
  masterChef: {
    80001: '',
    137: '0x40747E35d159829Bb26e4651a75C779b557bd305',
  },
  masterChefV1: {
    80001: '',
    137: '0x641084ecc9Ddb557BbA1eE3dE5fCcAf5E88159ED',
  },
  sousChef: {
    80001: '',
    137: '0xf026Ed6209fD445450dAe20DaaAD0C4ED98953C8',
  },
  lotteryV2: {
    80001: '',
    137: '0x9E13CFB9de11323d19e8a35b0e10dc9589Af289e',
  },
  multiCall: multicallAddresses,
  pancakeProfile: {
    137: '0x8aa8951ACfC78c7324E822cE86DD90B12CbF9737',
    80001: '',
  },
  pancakeBunnies: {
    137: '0x7E57F25D6cF3864669C3d9C208AeD1a3ACA77aB4',
    80001: '',
  },
  bunnyFactory: {
    137: '0xE444ee3aa11f6c6C1977DDE8849cF5073EBA7e1A',
    80001: '',
  },
  claimRefund: {
    137: '0x6c06e6fb07b5BaeF720228e478EEcf32DAd4aA5D',
    80001: '',
  },
  pointCenterIfo: {
    137: '0x6F8Df8094c683D69ec1d2A2B9beE24695120Ed2b',
    80001: '',
  },
  bunnySpecial: {
    137: '0xf78Faac38f76C95eCe925251505da5AB27b81bBe',
    80001: '',
  },
  tradingCompetitionEaster: {
    137: '0x91fbD0111a270D44a38727D3AB30504F4Ae29902',
    80001: '',
  },
  tradingCompetitionFanToken: {
    137: '',
    80001: '',
  },
  tradingCompetitionMobox: {
    137: '',
    80001: '',
  },
  tradingCompetitionMoD: {
    137: '',
    80001: '',
  },
  easterNft: {
    137: '0x9Eb1337E43Cea60542F148fAe87b98111805b19A',
    80001: '',
  },
  cakeVault: {
    137: '0xf508a363AE60213cdc360FA232bc781ed39DaF7b',
    80001: '',
  },
  cakeFlexibleSideVault: {
    137: '0xAc3bBFEE9f177d7473E12498e88d4d52E260151d',
    80001: '',
  },
  predictionsBNB: {
    137: '0xF6d6b497871E2A09E22e7E351088Aa7b6D87A38b',
    80001: '',
  },
  predictionsCAKE: {
    137: '0xF6d6b497871E2A09E22e7E351088Aa7b6D87A38b',
    80001: '',
  },
  chainlinkOracleBNB: {
    137: '0xAB594600376Ec9fD91F8e885dADF0CE036862dE0',
    80001: '',
  },
  chainlinkOracleCAKE: {
    137: '0xAB594600376Ec9fD91F8e885dADF0CE036862dE0',
    80001: '',
  },
  predictionsV1: {
    137: '0x334cd4337a8cac3FCc7d9EBcE8e1a449fD1b2846',
    80001: '',
  },
  bunnySpecialCakeVault: {
    137: '0x13E32266418b2f841325d43b639c2374b6Ab6556',
    80001: '',
  },
  bunnySpecialPrediction: {
    137: '',
    80001: '',
  },
  bunnySpecialLottery: {
    137: '',
    80001: '',
  },
  bunnySpecialXmas: {
    137: '',
    80001: '',
  },
  farmAuction: {
    137: '0xa9a649e24C6f87CB8073BAb111e43ba9C470A895',
    80001: '',
  },
  AnniversaryAchievement: {
    137: '',
    80001: '',
  },
  nftMarket: {
    137: '0x6d41E3289114679516418FC1A56bD50C7D90441b',
    80001: '',
  },
  nftSale: {
    137: '',
    80001: '',
  },
  pancakeSquad: {
    137: '0x06Fb7B950CCF16D4496b1579f5614eF95407E822',
    80001: '0xfC0c3F11fDA72Cb9A56F28Ec8D44C0ae4B3ABF86',
  },
  potteryDraw: {
    137: '0xad7c216Fa5aF3521861505e2e71017c41D0e4A3d',
    80001: '',
  },
  zap: {
    137: '0xaa9c43064D7f051c25878dB58eC383d2A12D2bF7',
    80001: '',
  },
  stableSwapNativeHelper: {
    137: '0x336Ed58d457051b17984b63bf191a0EF1f9cBDC1',
    80001: '',
  },
  iCake: {
    137: '0xd37cdeA7De7941A6C6e5B10643479f798571135E',
    80001: '',
  },
  bCakeFarmBooster: {
    137: '0xb31f9221916a0633151eFde6391a3ce876766F25',
    80001: '',
  },
  bCakeFarmBoosterProxyFactory: {
    137: '0xf1b16C6E62dED8C46D30b29bB3b8456bcF539Ae1',
    80001: '',
  },
  nonBscVault: {
    137: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
    1: '0x2e71B2688019ebdFDdE5A45e6921aaebb15b25fb',
    5: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  },
  crossFarmingSender: {
    137: '0x327d26dE30f92600620A99043034e0A5FD9402C8',
    1: '0x8EA90Ef07f37c77137453C7A1B72B7886d51eCFb',
    5: '0x327d26dE30f92600620A99043034e0A5FD9402C8',
  },
  crossFarmingReceiver: {
    137: '0x0726a8C8206b9eC0AfB788df5adb36a8AEDB13c2',
    80001: '0xBab5d3B6bA24E185f216419f3ba07f03984bF983',
  },
  mmLinkedPool: {
    1: '0x9Ca2A439810524250E543BA8fB6E88578aF242BC',
    5: '0x7bb894Ca487568dD55054193c3238d7B1f46BB92',
    137: '0x9Fa2615c88990f49A1a87De6C6fca928cb9B58D8',
  },
}
